import request from '@utils/request';
// 接口文档 http://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=f79cfbb4-96dd-4dae-8478-0bb1af408c5e
// 发送短信验证码
export async function loginCodeSend(params) {
  const res = await request.post(`/api/official/mobile/user/code/send`, params);
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=c321c17e-be36-4e19-bafc-37500707248b
// 点击按钮登录
export async function userLogin(params) {
  const res = await request.post(`/api/official/mobile/user/code/login`, params);
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=cb2fbfca-afc8-4105-b046-a37ab4e7242f
// 判断手机号是否有对应简历
export async function resumeSuspected(params) {
  const res = await request.post(`/api/official/mobile/user/suspected/query`, params);
  return res;
}

interface IGetLoginStatus {
  // userId: number; // 用户ID
  // tenantId: string; // 租户
  // openId: string; // 微信id
  avatarUrl: string; // 头像
  nickName: string; // 别名
  accountId: string;
  bindWechat: boolean; // 是否已绑定微信
  // countryCode: string; // 国家码
  // countryName: string; // 地区名
  // phone: string; // 电话
  // memo: string; //
  // staffMisId: string; // 如果绑定员工，员工的MIS号
  // staffTenantId: string; // 如果绑定员工，员工的租户Id （有可能其它租户的员工来看当前租户的职位信息）
  login: boolean; // 是否登录
  clientIp: string;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=1bb9ef4b-b2ac-4418-add3-378959f205d1
// 获取登录状态
export async function getLoginStatus(): Promise<IGetLoginStatus> {
  const res: IGetLoginStatus = await request.post(`/api/official/mobile/user/current/get`, {});
  return res;
}

// 接口文档 https://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=2a1a54ad-36e8-4078-9fcc-01259b53e4d0
// 登出
export async function logout() {
  const res = await request.post(`/api/official/mobile/user/logout`, {});
  return res;
}
